const ACTIVE_CLASS = 'active'
const FIXED_CLASS = 'fixed'

document.addEventListener('DOMContentLoaded', function() {
  const submenuItems = document.querySelectorAll('.nav-megamenu-short-courses-submenu-item');
  const megamenuContainer = document.querySelector('.nav-megamenu-short-courses');
  const bottomHeaderWrapper = document.querySelector('.bottom-header-wrapper');
  const megamenuToggleButton = document.querySelector('.nav-megamenu-short-courses-toggle');
  
  // Handle fixed header on scroll with throttling
  if (bottomHeaderWrapper) {
    const headerOffset = bottomHeaderWrapper.offsetTop;
    const headerHeight = bottomHeaderWrapper.offsetHeight;
    let ticking = false;
    let lastKnownScrollPosition = 0;
    
    window.addEventListener('scroll', function() {
      lastKnownScrollPosition = window.pageYOffset;

      if (!ticking) {
        requestAnimationFrame(() => {
          // Reset padding for mobile to prevent issues with fixed positioning on smaller screens
          if (window.innerWidth < 992) {
            document.body.style.paddingTop = '0';
          }

          if (lastKnownScrollPosition >= headerOffset) {
            bottomHeaderWrapper.classList.add(FIXED_CLASS);
            // Add padding to body to prevent jump when header becomes fixed, but only for desktop
            if (window.innerWidth >= 992) {
              document.body.style.paddingTop = headerHeight + 'px';
            }
          } else {
            bottomHeaderWrapper.classList.remove(FIXED_CLASS);
            // Remove padding when not fixed
            document.body.style.paddingTop = '0';
          }
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  // Toggle megamenu on click (this also includes pressing enter)
  if (megamenuToggleButton) {
    megamenuToggleButton.addEventListener('click', function(event) {
      event.preventDefault();
      this.classList.toggle(ACTIVE_CLASS);

      if (!this.classList.contains(ACTIVE_CLASS) && event.detail > 0) {
        // Only blur for clicks, not keyboard
        this.blur();
      }
    });
  }

  // Close megamenu when clicking the overlay or opening the cart
  document.addEventListener('click', function(event) {
    if (!megamenuToggleButton || !megamenuToggleButton.classList.contains(ACTIVE_CLASS)) return;

    const isInsideHeader = event.target.closest('.bottom-header-wrapper, .top-header');
    const isCartTrigger = event.target.closest('.openCartDrawer');

    if (!isInsideHeader || isCartTrigger) {
      megamenuToggleButton.classList.remove(ACTIVE_CLASS);
    }
  });
  
  // Reveal collection course list/featured on submenu item click or hover
  if (submenuItems.length > 0) {
    submenuItems.forEach(item => {
      item.addEventListener('click', function() {
        handleSubmenuItemActivation(this);
      });
      
      item.addEventListener('mouseenter', function() {
        handleSubmenuItemActivation(this);
      });
    });
  }
  
  // Reset to popular courses when mouse leaves the megamenu
  if (megamenuContainer) {
    megamenuContainer.addEventListener('mouseleave', function() {
      handleSubmenuItemActivation(null, 'popular-courses');
    });
  }
  
  // Handle collection submenu activation and content display
  function handleSubmenuItemActivation(element, collectionHandleOverride) {
    const collectionHandle = collectionHandleOverride || element.getAttribute('data-collection-handle');
    
    if (!collectionHandle) return;
    
    // Remove active class from all submenu items
    submenuItems.forEach(item => {
      item.classList.remove(ACTIVE_CLASS);
    });

    // Remove active class from all content containers
    const allContainers = document.querySelectorAll('.content-container');
    allContainers.forEach(container => {
      container.classList.remove(ACTIVE_CLASS);
    });
    
    // Add active class to current submenu item
    if (element) {
      element.classList.add(ACTIVE_CLASS);
    }
    
    // Add active class to matching content container
    const targetContainer = document.querySelector(`.content-container[data-collection-handle="${collectionHandle}"]`);
    if (targetContainer) {
      targetContainer.classList.add(ACTIVE_CLASS);
    }
  }
});
